import * as theme from "../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import { getBrokerInformation, isSignupResponse } from "../store/broker";
import { getBrokerageInformation, getDetails } from "../store/brokerage";
import PerfectScrollbar from "react-perfect-scrollbar";
import Select from "react-select";
import UploadBrokerImage from "../components/UploadBrokerImage";
import {
  getUserInformation,
  getUserDetails,
  getUpdateButtonStatus,
  toggleUpdateButton,
  geNewUserModelStatus,
  toggleNewUserModel,
  getUpdateUserModelStatus,
  toggleUpdateUserModel,
  selectUpdateUser,
  getUpdateUserSelected,
  updateDetails,
  getAllUsersList,
  getAllUsers,
  addNewUser,
  getUpdateErrors,
  getBrokerageInfo,
} from "../store/userManagement";
import { toast } from "react-toastify";
import { tr } from "date-fns/locale";
import { sendSignupEmail, storeEmailId } from "../store/passwordManagement";
import {
  addNewGroup,
  createGroupModalClosed,
  createGroupModalOpened,
  getAllGroupList,
  getGroupListData,
  getGroupModalOpen,
  getGroupSuccess,
  getSelectedGroupObject,
  groupObjectNull,
  updateSingleGroupObject,
} from "../store/groupManagement";
import translations from "../utils/translations";
const GroupManagement = () => {
  return <GroupManagementPane></GroupManagementPane>;
};
const GroupManagementPane = () => {
  const isUpdateEnabled = useSelector(getUpdateButtonStatus);
  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  const [isLoading, setIsLoading] = useState(false);
  const languagepreference = broker.information.languagepreference;
  const translationsBrokerAdmin =
    translations[languagepreference].brokerageAdmin;
  let data = { brokerage_code: broker.information.brokerages[0].code };
  const [addressList, setAddressList] = useState(null);
  useEffect(() => {
    dispatch(getUserDetails(data)).then(
      setTimeout(() => {
        dispatch(getDetails(data));
      }, 100)
    );
  }, []);
  useEffect(async () => {
    setIsLoading(true);
    await dispatch(getAllGroupList());
    await dispatch(getAllUsers());
    setIsLoading(false);
  }, []);
  const brokerage_info = useSelector(getBrokerageInformation);
  const groupListData = useSelector(getGroupListData);
  useEffect(() => {
    setAddressList(brokerage_info);
  }, [brokerage_info]);

  let userList = useSelector(getUserInformation);

  const onUpdateChangeHandle = (value) => {
    dispatch(toggleUpdateButton(value));
  };

  const onNewGroupModelChangeHandle = () => {
    dispatch(groupObjectNull());
    dispatch(createGroupModalOpened());
  };

  const onUpdateGroupModelChangeHandle = (user) => {
    dispatch(updateSingleGroupObject(user));
    dispatch(createGroupModalOpened());
  };

  return (
    <div className="m-4">
      <div className="d-flex">
        <div
          className="m-4"
          style={{
            width: "100%",
          }}
        >
          <div
            className="d-flex"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.2vw",
            }}
          >
            {translationsBrokerAdmin.infoText}
          </div>

          <div
            className="d-flex m-2"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              paddingTop: "25px",
              fontSize: "0.8vw",
            }}
          >
            <table className="table table-sm">
              <thead>
                <tr>
                  <th scope="col">
                    {translationsBrokerAdmin.tableHeaderTitle}
                  </th>
                  <th scope="col" className="text-center">
                    {translationsBrokerAdmin.tableHeaderAction}
                  </th>
                </tr>
              </thead>
              <tbody>
                {groupListData && groupListData.length > 0 ? (
                  groupListData.map((user, index) => (
                    <tr key={index}>
                      <td>
                        {user?.title || translationsBrokerAdmin.noGroupData}
                      </td>
                      <td className="text-center">
                        <Button
                          style={{
                            color: "white",
                            height: "3.5vh",
                            fontFamily: "GibsonSemiBd",
                            fontSize: 12,
                            backgroundColor: theme.COLORS.secondary_skyblue,
                            border: 0,
                            width: "5vw",
                          }}
                          onClick={() => onUpdateGroupModelChangeHandle(user)}
                        >
                          {translationsBrokerAdmin.buttonUpdate}
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">
                      {isLoading
                        ? translationsBrokerAdmin.loading
                        : translationsBrokerAdmin.noGroupData}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div>
            <Button
              style={{
                color: "white",
                height: "4vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                border: 0,
                width: "10vw",
              }}
              onClick={onNewGroupModelChangeHandle}
            >
              {translationsBrokerAdmin.buttonAddNewGroup}
            </Button>
          </div>
        </div>
      </div>
      <AddGroupModal
        brokerageCode={data.brokerage_code}
        brokerageAddressList={addressList ? addressList.address : []}
      />
    </div>
  );
};

const AddGroupModal = (props) => {
  const newGroupModalState = useSelector(getGroupModalOpen);

  let userList = useSelector(getUserInformation);
  const updateGroupData = useSelector(getSelectedGroupObject);
  return (
    <Modal
      size="md"
      isOpen={newGroupModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "65vh",
          width: "40vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <NewGroup
        brokerageCode={props.brokerageCode}
        brokerageAddressList={props.brokerageAddressList}
      ></NewGroup>
    </Modal>
  );
};

const NewGroup = (props) => {
  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  const updateGroupData = useSelector(getSelectedGroupObject);
  const userData = useSelector(getUserInformation);
  const APIMessage = useSelector(getGroupSuccess);
  const [groupName, setGroupName] = useState(null);
  const [userGroup, setUserGroup] = useState(null);
  const [titleError, setTitleError] = useState("");
  const [userGroupError, setUserGroupError] = useState("");
  useEffect(() => {
    setGroupName(updateGroupData?.title);
    setUserGroup(
      updateGroupData.brokerList?.map((grpArray) => {
        return { label: grpArray?.fullname, value: grpArray?._id };
      })
    );
  }, [updateGroupData]);
  const previewCanvasRef = useRef(null);
  const onAddButtonClick = async () => {
    const groupDataObject = {
      title: groupName,
      brokerlist: userGroup?.map((data) => data.value),
      brokeragecode: broker?.information?.brokeragecode,
    };
    const groupDataObjectForUpdate = {
      _id: updateGroupData._id,
      title: groupName,
      brokerlist: userGroup?.map((data) => data.value),
      brokeragecode: updateGroupData?.brokeragecode,
    };
    if (
      (groupName == "" || groupName == undefined) &&
      (userGroup == "" || userGroup == undefined)
    ) {
      setTitleError("this field is required");
      setUserGroupError("this field is required");
    }
    if (groupName == "" || groupName == undefined) {
      setTitleError("this field is required");
    } else if (userGroup == "" || userGroup == undefined) {
      setUserGroupError("this field is required");
    } else {
      dispatch(
        addNewGroup({
          reminderGroup: updateGroupData
            ? groupDataObjectForUpdate
            : groupDataObject,
        })
      ).then(() => {
        dispatch(createGroupModalClosed());
        toast.success(
          updateGroupData.title ? "Group Updated" : "Group Added Successfully"
        );
        dispatch(getAllGroupList());
      });
    }
  };

  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div
            className="text-center"
            style={{ fontFamily: "GibsonSemiBd", fontSize: "24px" }}
          >
            {updateGroupData.title ? "Update a group" : "Add a new group"}
          </div>

          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="large"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(groupObjectNull());
                dispatch(createGroupModalClosed());
              }}
            ></CancelIcon>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-10">
            <form noValidate>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Title</label>
                <div className="col-sm-8">
                  <input
                    autoFocus
                    type="text"
                    id="uName"
                    name="uName"
                    className="form-control"
                    placeholder="Enter Name"
                    required
                    style={{ backgroundColor: "#fff" }}
                    onChange={(event) => {
                      setGroupName(event.target.value);
                      setTitleError("");
                    }}
                    value={groupName}
                  />
                  {titleError && (
                    <p style={{ color: "red" }}>Please enter title</p>
                  )}
                </div>
              </div>
              <section
                style={{
                  minHeight: "8vh",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  paddingTop: "2vh",
                }}
              >
                <div
                  style={{
                    width: "35%",
                    height: "100%",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  User Team
                </div>
                <div style={{ width: "65%", minHeight: "100%" }}>
                  <Select
                    style={{
                      width: "100%",
                      height: "6vh",
                      fontSize: "1.9vmin",
                      border: "5px solid white",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }}
                    className="form-select"
                    onChange={(e) => {
                      setUserGroup(e);
                      setUserGroupError("");
                    }}
                    isMulti
                    value={userGroup}
                    placeholder="Select an option"
                    isRequired
                    options={
                      userData &&
                      userData.map((item) => {
                        return {
                          value: item._id,
                          label: `${item?.firstname} ${item?.lastname}`,
                        };
                      })
                    }
                  />
                  {userGroupError && (
                    <p style={{ color: "red" }}>Please Select Option</p>
                  )}
                </div>
              </section>

              <div
                className="form-group row justify-content-center "
                style={{ paddingTop: "9rem", marginLeft: "27px" }}
              >
                <div className="col-6">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#4cabd4",
                      borderRadius: "20px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      onAddButtonClick();
                    }}
                  >
                    {updateGroupData?.title
                      ? "Update a group"
                      : "Add a new group"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};
export default GroupManagement;
